import React, { useEffect } from 'react'
import FormattedMessage from '../../../helpers/FormattedMessage'

import styles from './ThanksPage.module.scss'


export const ThanksPage = () => {
  useEffect(() => {
    window.localStorage.clear()
  }, [])

  return (
    <>
      <div className={styles.Wrapper}>
        <div className={styles.TextBlock}>
          <h3 className={styles.Title}><FormattedMessage id="ThanksPage.title"/></h3>
          <h1 className={styles.SubTitle}><FormattedMessage id="ThanksPage.subtitle"/></h1>
          <p className={styles.Text}><FormattedMessage id="ThanksPage.text"/></p>
        </div>

      </div>
    </>
  )
}
